export default "__VITE_ASSET__DrmO6H8V__"